import { TicketRadioType, PassengerSetType, TrainOfferRequest } from "../../../../Orchestrator/Types/Index"

export class TicketOptionContext {
    public ticketRadioType!: TicketRadioType;
    public passengerSetType!: PassengerSetType;
    public trainOfferRequest!: TrainOfferRequest;
    public routeTo: string[] = []
    public nextTo: string[] = []
    public isAnonymous: boolean = false;
}

export const ticketOptionContext = new TicketOptionContext()
